// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Register service worker for PWA support
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/service-worker.js")
}
